import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

import App from './components/App';

import 'bootstrap/dist/css/bootstrap.min.css';

import './css/index.css';

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
